module.exports = __webpack_public_path__ + "img/tool.90c9036d.svg";